(function ($) {
  'use strict';
  $(function () {
    var body = $('body');
    //var contentWrapper = $('.content-wrapper');
    //var scroller = $('.container-scroller');
    //var footer = $('.footer');
    var sidebar = $('.sidebar');

    //Add active class to nav-link based on url dynamically
    //Active class can be hard coded directly in html file also as required
    var current = location.pathname.split("/").slice(-1)[0].replace(/^\/|\/$/g, '');
    $('.nav li a', sidebar).each(function () {
      var $this = $(this);
      if (current === "") {
        //for root url
        if ($this.attr('href').indexOf("index.html") !== -1) {
          $(this).parents('.nav-item').last().addClass('active');
          if ($(this).parents('.sub-menu').length) {
            $(this).addClass('active');
          }
        }
      } else {
        //for other url
        if ($this.attr('href').indexOf(current) !== -1) {
          $(this).parents('.nav-item').last().addClass('active');
          if ($(this).parents('.sub-menu').length) {
            $(this).addClass('active');
          }
          if (current !== "index.html") {
            $(this).parents('.nav-item').last().find(".nav-link").attr("aria-expanded", "true");
            if ($(this).parents('.sub-menu').length) {
              $(this).closest('.collapse').addClass('show');
            }
          }
        }
      }
    });

    //Close other submenu in sidebar on opening any

    sidebar.on('show.bs.collapse', '.collapse', function () {
      sidebar.find('.collapse.show').collapse('hide');
    });


    //Change sidebar and content-wrapper height
    //applyStyles();
    //Applying perfect scrollbar
    // function applyStyles() {
    //   if (!body.hasClass("rtl")) {
    //     if ($('.settings-panel .tab-content .tab-pane.scroll-wrapper').length) {
    //       const settingsPanelScroll = new PerfectScrollbar('.settings-panel .tab-content .tab-pane.scroll-wrapper');
    //     }
    //     if ($('.chats').length) {
    //       const chatsScroll = new PerfectScrollbar('.chats');
    //     }
    //     if ($('.scroll-container').length) {
    //       const ScrollContainer = new PerfectScrollbar('.scroll-container');
    //     }
    //     if (body.hasClass("sidebar-fixed")) {
    //       const fixedSidebarScroll = new PerfectScrollbar('#sidebar .nav');
    //     }
    //   }
    // }

    $('[data-toggle="minimize"]').on("click", function () {
      if ((body.hasClass('sidebar-toggle-display')) || (body.hasClass('sidebar-absolute'))) {
        body.toggleClass('sidebar-hidden');
      } else {
        body.toggleClass('sidebar-icon-only');
      }
    });

    //checkbox and radios
    $(".form-check label,.form-radio label").append('<i class="input-helper"></i>');

    //init datetime picker on all date time pickers
    $('.datetimepicker').datetimepicker({timepicker:false});

// Attach function to all reveal_password links
    $('.reveal_password').on('click', function () {
      let placeholder = "-MASKED-";
      let ele_id = $(this).data('for');
      let ele = document.getElementById(ele_id);
      if (ele !== null) {
        let val = $(ele).data('value');
        if (val != '') {
          let ele_txt = $(ele).text();
          if (ele_txt == val) {
            $(ele).text(placeholder);
          } else {
            $(ele).text(val);
          }
        }
        if (ele.type == 'password') {
          ele.type = 'text';
        } else {
          ele.type = 'password';
        }
      }
    });

    //Confirm Delete
    $('.confirm-delete').click(function(e){
      e.preventDefault();
      let $link = $(this).attr('href');
      let answer = window.confirm("Delete this server?");
      if (answer) {
        window.location = $link;
      }
    });

  });
})(jQuery);



// WEBPACK FOOTER //
// ./scripts/routes/admin/partials/misc.js